<div class="wrapper">
  <div class="main-row">
    <div class="d-logo">
      <a [href]="frLoc+'/home'">
        <img alt="Deloitte" height="20" ngSrc="/assets/images/d-logo.svg" width="85">
      </a>
    </div>
    <div [class.fr-logo]="isFrLogo" class="project-logo">
      @if (currentFrItem) {
        <a [href]="frLoc+'/home'">
          @switch (currentFrItem.country) {
            @case (E_COUNTRY.Canada) {
              @if (currentFrItem.route === E_FR_LOC.caFr) {
                <img alt="Canada Centre for Financial Reporting"
                     height="20"
                     width="325"
                     style="margin-top: 3px"
                     ngSrc="/assets/images/ias-logo-canada-fr.svg">
              } @else {
                <img alt="Canada Centre for Financial Reporting"
                     height="20"
                     width="323"
                     style="margin-top: 3px"
                     ngSrc="/assets/images/ias-logo-canada.svg">
              }
            }
            @case (E_COUNTRY.UnitedKingdom) {
              <img alt="Accounting Plus"
                   style="margin-top: 3px"
                   height="20" width="148" ngSrc="/assets/images/ias-logo-uk.svg">
            }
            @default {
              <img alt="IAS Plus" height="20" ngSrc="/assets/images/ias-logo.svg" width="80">
            }
          }
        </a>
      }
    </div>
    <div class="search-wrapper">
      <app-search-input (buttonOrEnterClicked)="navigateToSearch()"
                        [formControl]="searchValue"></app-search-input>
    </div>
    <div class="mobile-section">
      @if (isSearchOpen) {
        <app-search-input
          class="mobile-search"
          [formControl]="searchValue"
          [isCross]="true"
          (buttonOrEnterClicked)="navigateToSearch()"
          (emitCloseSearch)="toggleSearch()"
        ></app-search-input>
      } @else {
        <i class="icon-SearchDensity-1" (click)="toggleSearch()"></i>
      }
      <i [class.icon-X]="isSideMenuOpen"
         [class.icon-HamburgerMenu]="!isSideMenuOpen"
         (click)="toggleSideMenu()"></i>
    </div>
    <div class="language-wrapper">
      @if (frItems && frItems.length) {
        <app-language-dropdown
          (frChange)="onFrChange($event)"
          [franchises]="franchises"></app-language-dropdown>
      }
    </div>
    @if (HELPER.loginEnabled) {
      <div class="user-wrapper">

        @if (user) {
          <app-profile-dropdown [user]="user" [currentFr]="currentFrItem"></app-profile-dropdown>
        } @else {
          <app-button [ariaLabel]="'Login' | translate" [noWordWrap]="true" [buttonStyleType]="ButtonTypes.PRIMARY_0"
                      (clicked)="openDialog()">{{ 'Login' | translate }}
          </app-button>
        }

      </div>
    }
  </div>

  <nav #navigation class='greedy links-row'>
    <ul #linksWrapper class='links'>
      <li class="greedy-links" routerLinkActive="active">
        <a [queryParams]="{'tag-type':getTags(homeItem)}"
           [routerLink]="getUrl(homeItem)"
           routerLinkActive="active">
          {{ 'Home'|translate }}
        </a>
        <div class="underline"></div>
      </li>
      @for (tab of menuItems; track tab.folderId) {
        <li class="greedy-links" [ngClass]="{active : tab.id === rootFolderId}">
          <a [routerLink]="getUrl(tab)"
             [queryParams]="{'tag-type':getTags(tab)}">
            {{ tab.title }}
          </a>
          <div class="underline"></div>
        </li>
      }

    </ul>

    <div [class.hidden]="noItemsToHide" class="more-menu">
      <div (click)="$event.stopPropagation();toggleMenuDropdown()" class="dots">
        <div class="three-dots"></div>
        <span class="icon icon-CaretDown"></span>
      </div>
      <ul #hiddenLinks
          (click)="toggleMenuDropdown(true)"
          (clickOutside)="toggleMenuDropdown(true)"
          [class.closed]="!menuDropdownIsOpen" class='hidden-links'>
      </ul>
    </div>

  </nav>
</div>
